
import { Component, Prop, Vue } from 'vue-property-decorator';
import Branch from '@/components/Branch.vue';
import { IconRegistry } from '@/lib/IconRegistry';
import InsurerLandingDefault from "./InsurerLandingDefault.vue";

@Component(
    {
        components: {
            InsurerLandingDefault,
            Branch,
        },
    },
)
export default class Home extends Vue {
    public illustrationIndex = 1;
    public illustrationSlideInterval = 0;

    public changeIllustrationIndex(index: number) {
        this.illustrationIndex = index;
    }

    public nextIllustration() {
        if (this.illustrationIndex === 3) {
            this.illustrationIndex = 1;
        } else {
            this.illustrationIndex++;
        }
    }

    public previousIllustration() {
        if (this.illustrationIndex === 1) {
            this.illustrationIndex = 3;
        } else {
            this.illustrationIndex--;
        }
    }

    mounted() {

        // console.log(this.$store.state.insurerLock);
        this.$store.commit('hideBanner');
        this.illustrationSlideInterval = setInterval(() => {
            this.nextIllustration();
        }, 5000);
        if (this.$route.query.hasOwnProperty("thank")) {
            const name = this.$route.query.thank as string;
            if (name.trim().length) {
                this.$store.commit("openModal", { type: 'thank-you', name: name.trim() });
            }
            this.$router.push(this.$route.path);
        }
        // if (this.$store.state.insurerLock) {
        //     this.$router.push('InsurerLandingDefault');
        // }
    }

    destroy() {
        clearInterval(this.illustrationSlideInterval);
    }

    public getIcon(iconName: string) {
        return '/static/' + IconRegistry.getIcon('branch', iconName);
    }

    //        mounted(){
    //            Velocity(this.$refs.branchItem, 'transition.flipXIn', {duration: 1500})
    //        }
}
